import { inject, Injectable } from '@angular/core';
import { FeatureFlagEnum } from '@models/enums/feature-flag.enum';
import { EnvironmentService } from '@services/environment/environment.service';
import { FeatureFlags } from '@models/environment.model';
import { CmsService } from '@services/cms/cms.service';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService {
  private cmsService = inject(CmsService);
  private readonly featureFlags: FeatureFlags;

  constructor() {
    // This service now reads the environment flags once on initialization.
    this.featureFlags = EnvironmentService.environment.featureFlags;
    const commonCopy = this.cmsService.appCommonPageCopy();
    if (commonCopy) {
      // If the CMS provides a value for a feature flag, use it to override
      // whatever is in the environment. This allows CMS to enable/disable
      // features without requiring a change to environment config.
      for (const key of Object.values(FeatureFlagEnum)) {
        if (commonCopy[key] !== undefined && this.isFeatureActive(key)) {
          this.featureFlags[key] =
            commonCopy[key].toLowerCase() === 'true' ? 'true' : '';
        }
      }
    }
  }

  /**
   * Gets the content for the given CMS key
   * as a JavaScript object.
   *
   * @param feature The Feature Flag key
   * @returns boolean value of feature requested
   */
  isFeatureActive = (feature: FeatureFlagEnum): boolean =>
    typeof this.featureFlags[feature] === 'string' &&
    this.featureFlags[feature]?.toLowerCase() === 'true';
}
